import { formatToTimeZone } from 'date-fns-timezone'

export const checkAfterHours = ({
    asset,
    setFormValues,
    formValues,
    setAfterHoursModalOpen,
    onCreateRequest,
}) => {
    setFormValues(formValues)

    // Use shipto timezone or default to Eastern timezone
    const timeZone = asset?.shipto?.timezone || 'America/New_York'

    // Get hour and day in the asset's timezone
    const now = new Date()
    const twentyFourHourFormat = 'H'
    const weekdayNumberFormat = 'd'
    const timeZoneHour = formatToTimeZone(now, twentyFourHourFormat, {
        timeZone,
    })
    const timeZoneDay = formatToTimeZone(now, weekdayNumberFormat, { timeZone })

    // Define after-hours conditions
    const isOutsideServiceHours = timeZoneHour < 6 || timeZoneHour >= 14
    const monday = 1
    const friday = 5
    const isWeekday = timeZoneDay >= monday && timeZoneDay <= friday
    const isAfterHours = (isOutsideServiceHours && isWeekday) || !isWeekday

    // Trigger the appropriate action
    if (isAfterHours) {
        setAfterHoursModalOpen(true)
    } else {
        onCreateRequest(null, formValues)
    }
}
